import { Suspense } from 'react'

import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { SubscriptionsBreadcrumb } from '../SubscriptionBreadcrumbs'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { DataTable } from '@/components/ui/DataTable'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { useCurrentOrganisation } from '../useCurrentOrganisation'
import { useRestClient } from '@/contexts/QueryProvider'
import { OrgTeamForm } from '../Forms/OrgTeamForm'
import { columns } from './OrganisationTeamsPage/orgTeamsTableColumns'

export function OrganisationTeamsPage() {
  return (
    <>
      <SubscriptionsBreadcrumb title="Teams" />
      <QueryErrorBoundary errorMessage="Failed to fetch organisation">
        <Suspense fallback={<LoadingComponent className="flex-1" />}>
          <OrganisationTeamsPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function OrganisationTeamsPanelContent() {
  const { name: orgName, id: orgId } = useCurrentOrganisation()

  const { getSubscriptionsApiGetOrganisationTeams } = useRestClient()

  const { data: applicationTeams } = getSubscriptionsApiGetOrganisationTeams.useSuspenseQuery({
    query: { orgId },
  })

  return (
    <TablePageContainer>
      <DataTable
        columns={columns}
        data={applicationTeams}
        action={
          <OrgTeamForm
            sheetTitle={`${orgName} > Create new team`}
            sheetTrigger={
              // <Button disabled={!isAddTeamAllowed} size="sm" variant="outline">
              <Button size="lg" variant="outline">
                <IconPlusOutline className="mr-2" />
                Create new team
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
